import { dataLayerPush } from 'src/helpers/gtm';

/**
 * Событие нажатия на кнопку “Войти“ из избранного
 */
export const pushWishlistAuth = () => {
  dataLayerPush({ event: 'wishlist_auth' });
};
